'use client';

import { useTranslations } from 'next-intl';
import { Link } from '~/components/Link';
// locale-aware: strips the `/en-US` prefix, without which destination detection below silently fails
import { usePathname } from '~/i18n/navigation';
import { trackEvent } from '~/utils';
import { BuildTripButton } from '../Playground/BuildTripButton/BuildTripButton';
import styles from './HeroCta.module.css';

type HeroCtaProps = {
  variant?: string | null;
};

const HeroCta = ({ variant }: HeroCtaProps) => {
  const pathname = usePathname();
  const t = useTranslations('navigation');
  const isForcedDestinationPage =
    pathname?.includes('/destination/') && process.env.NEXT_PUBLIC_FORCE_DESTINATION_HERO_CTA === 'true';

  const isDestinationPage = pathname?.startsWith('/destination/');
  const segments = pathname?.split('/').filter(Boolean) ?? [];
  const rawDestination = isDestinationPage && segments.length >= 2 ? segments[1] : null;
  const destination = rawDestination
    ? rawDestination
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : null;

  const browseTripsHref =
    isDestinationPage && destination
      ? `/blueprint-index?${new URLSearchParams({ destination }).toString()}`
      : '/blueprint-index';

  if (variant === 'build' || isForcedDestinationPage) {
    return (
      <div className={styles.ctaGroup}>
        <div className={styles.createTripWrapper}>
          <BuildTripButton variant="heroCta" />
        </div>
        <div className={styles.browseTripsWrapper}>
          <Link
            href={browseTripsHref}
            asButton="tertiary"
            data-ua-click="header_browse"
            onClick={() => {
              trackEvent('header_browse', {
                event_category: 'bpi',
                event_action: 'click',
                event_label: 'header_browse'
              });
            }}
          >
            {t('browse_trips')}
          </Link>
        </div>
      </div>
    );
  }

  return null;
};

export default HeroCta;
